/* Shapers Club — Board Customizer (moteur générique, piloté par un JSON de config)
   Un shaper = un fichier assets/customizer-xxx.json. Aucune dépendance. */
(function () {
  'use strict';

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var ftIn = function (n) { return Math.floor(n / 12) + "'" + (n % 12) + '"'; };
  var cm = function (n) { return Math.round(n * 2.54); };

  function Customizer(root) {
    this.root = root;
    this.opts = {
      configUrl: root.dataset.configUrl,
      configFallback: root.dataset.configFallback || '',
      variantId: root.dataset.variantId,
      delivery: root.dataset.delivery || '',
      deadline: root.dataset.deadline || '',
      redirect: root.dataset.redirect || '/checkout',
      cartAddUrl: root.dataset.cartAddUrl || '/cart/add.js',
      // mode « pièce fixe » (La Cave) : le shape existe déjà, on ne choisit que la finition
      fixed: root.dataset.fixed === 'true',
      fixedTitle: root.dataset.fixedTitle || '',
      fixedVendor: root.dataset.fixedVendor || '',
      fixedSku: root.dataset.fixedSku || '',
      fixedPrice: parseFloat(root.dataset.fixedPrice || '0') || 0,
      fixedImage: root.dataset.fixedImage || ''
    };
    this.state = {
      model: null, lengthIn: null, dimsMode: 'tyler', width: '', thickness: '',
      extras: {},      // catKey -> { optKey: {colors:[...]} }
      view: 'top', step: 1,
      rider: { weight: '', height: '', level: '', waves: '', spot: '', notes: '' },
      busy: false, error: ''
    };
    this.load();
  }

  // t('clef', 'texte francais') : rend la surcharge de langue si le fichier
  // de config en fournit une, sinon le francais d'origine.
  Customizer.prototype.t = function (k, fr) {
    var d = this.i18n || {};
    return (d && typeof d[k] === 'string' && d[k]) || fr;
  };

  Customizer.prototype.load = function () {
    var self = this;
    var inline = this.root.querySelector('script[type="application/json"][data-config]');
    if (inline) { this.cfg = JSON.parse(inline.textContent); return this.init(); }
    // Le fichier de config depend de la langue. S'il n'existe pas pour la
    // langue demandee, on retombe sur celui de la langue par defaut plutot
    // que d'afficher une erreur.
    var charger = function (url) {
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      });
    };
    charger(this.opts.configUrl).catch(function (e) {
      if (!self.opts.configFallback || self.opts.configFallback === self.opts.configUrl) throw e;
      return charger(self.opts.configFallback);
    }).then(function (cfg) {
      self.cfg = cfg;
      self.i18n = cfg.i18n || {};
      self.init();
    }).catch(function () {
      self.root.innerHTML = '<p class="bc-error">Configurateur indisponible. Contactez-nous : contact@shapersclub.com</p>';
    });
  };

  Customizer.prototype.init = function () {
    var self = this;
    // bulle de chat présente ? -> la barre d'achat mobile laisse la place (cf. .bc--chat)
    var chk = function () { if (document.getElementById('zipchat-shadow-host')) self.root.classList.add('bc--chat'); };
    chk(); setTimeout(chk, 2000); setTimeout(chk, 6000);
    // pré-sélection via ?model=777
    if (this.opts.fixed) this.initFixed();
    var m = this.opts.fixed ? null : new URLSearchParams(location.search).get('model');
    if (m) {
      var found = this.cfg.models.filter(function (x) { return x.key.toLowerCase() === m.toLowerCase(); })[0];
      if (found) { this.pickModel(found.key, true); this.state.step = 2; }
    }
    this.root.addEventListener('click', function (e) { self.onClick(e); });
    this.root.addEventListener('input', function (e) { self.onInput(e); });
    this.root.addEventListener('change', function (e) { self.onInput(e); });
    this.render();
  };

  Customizer.prototype.initFixed = function () {
    var o = this.opts, t = o.fixedTitle;
    // La longueur est lue dans le titre. On parcourt toutes les occurrences et on
    // retient la premiere valeur plausible pour une planche (3' a 12'6"), sinon un
    // nom de modele comme « 90's Natt » serait lu comme 90 pieds et toutes les
    // options tomberaient hors grille, donc « sur devis ».
    var rxLen = /(\d{1,2})\s*[′'’]\s*(\d{1,2})?/g, mm, len = 0, v;
    while ((mm = rxLen.exec(t)) !== null) {
      v = (+mm[1]) * 12 + (+(mm[2] || 0));
      if (v >= 36 && v <= 150) { len = v; break; }
    }
    var parts = t.split(' — ')[0].split(' - ');
    var dims = parts.length > 2 ? parts.slice(2).join(' - ') : '';
    this.cfg.brand = o.fixedVendor || parts[0] || this.cfg.brand;
    this.cfg.models = [{
      key: 'fixed', name: (parts[1] || t).trim(), subtitle: '', desc: '', suited: '', dims: dims,
      minIn: len, maxIn: len, defaultIn: len, images: { top: o.fixedImage, bottom: o.fixedImage }, refDims: []
    }];
    this.cfg.priceTiers = [{ minIn: 0, maxIn: 9999, label: '', price: o.fixedPrice }];
    this.state.model = 'fixed'; this.state.lengthIn = len; this.state.step = 2;
  };

  /* ---------- calculs ---------- */
  Customizer.prototype.model = function () {
    var k = this.state.model;
    return this.cfg.models.filter(function (x) { return x.key === k; })[0] || null;
  };
  Customizer.prototype.tier = function (len) {
    // un modèle peut avoir sa propre grille (ex. finition différente) ; sinon grille commune
    var m = this.model(), tiers = (m && m.priceTiers) || this.cfg.priceTiers;
    return tiers.filter(function (t) { return len >= t.minIn && len <= t.maxIn; })[0] || null;
  };
  Customizer.prototype.basePrice = function () {
    if (!this.state.lengthIn) return 0;
    var t = this.tier(this.state.lengthIn); return t ? t.price : 0;
  };
  Customizer.prototype.optPrice = function (opt) {
    var len = this.state.lengthIn || 0;
    for (var i = 0; i < opt.tiers.length; i++) if (len <= opt.tiers[i].maxIn) return opt.tiers[i].price;
    return null; // hors grille -> sur devis
  };
  Customizer.prototype.selected = function () {
    var out = [], self = this;
    this.cfg.extras.forEach(function (cat) {
      var sel = self.state.extras[cat.key] || {};
      cat.options.forEach(function (o) {
        if (sel[o.key]) out.push({ cat: cat, opt: o, price: self.optPrice(o), colors: sel[o.key].colors || [] });
      });
    });
    return out;
  };
  Customizer.prototype.totals = function () {
    var base = this.basePrice(), extras = 0, quote = false;
    this.selected().forEach(function (s) { if (s.price == null) quote = true; else extras += s.price; });
    var total = base + extras;
    return { base: base, extras: extras, total: total, deposit: this.cfg.deposit, balance: Math.max(0, total - this.cfg.deposit), quote: quote };
  };

  /* ---------- actions ---------- */
  Customizer.prototype.pickModel = function (key, silent) {
    this.state.model = key;
    var m = this.model();
    this.state.lengthIn = m.defaultIn || m.minIn;
    this.state.extras = {}; this.state.view = 'top';
    if (!silent) { this.state.step = 2; this.render(true); }
  };

  Customizer.prototype.toggleOpt = function (catKey, optKey) {
    var cat = this.cfg.extras.filter(function (c) { return c.key === catKey; })[0];
    var sel = this.state.extras[catKey] || {};
    if (sel[optKey]) delete sel[optKey];
    else { if (!cat.multi) sel = {}; sel[optKey] = { colors: [] }; }
    this.state.extras[catKey] = sel;
    this.render();
  };

  Customizer.prototype.onClick = function (e) {
    var t = e.target.closest('[data-act]'); if (!t) return;
    var a = t.dataset.act, s = this.state;
    if (a === 'model') return this.pickModel(t.dataset.key);
    if (a === 'step') {
      var n = +t.dataset.step;
      if (n > 1 && !s.model) return;
      s.step = n; return this.render(true);
    }
    if (a === 'view') { s.view = t.dataset.view; return this.render(); }
    if (a === 'dims') { s.dimsMode = t.dataset.mode; return this.render(); }
    if (a === 'opt') return this.toggleOpt(t.dataset.cat, t.dataset.opt);
    if (a === 'color') {
      var sel = (s.extras[t.dataset.cat] || {})[t.dataset.opt]; if (!sel) return;
      sel.colors[+t.dataset.slot] = t.dataset.name; return this.render();
    }
    if (a === 'submit') return this.submit();
  };

  Customizer.prototype.onInput = function (e) {
    var f = e.target.dataset.field; if (!f) return;
    var s = this.state, v = e.target.value;
    if (f === 'length') { s.lengthIn = +v; return this.render(); }
    // pas de re-rendu ici : reconstruire la barre pendant un blur annulerait le clic sur « Réserver »
    if (f === 'width' || f === 'thickness') { s[f] = v; return; }
    s.rider[f] = v;
  };

  /* ---------- propriétés de ligne ---------- */
  Customizer.prototype.properties = function () {
    var s = this.state, m = this.model(), t = this.totals(), c = this.cfg.currency, p = {};
    p['Modèle'] = this.cfg.brand + ' — ' + m.name;
    if (this.opts.fixed && this.opts.fixedSku) p['Réf. shape'] = this.opts.fixedSku;
    p['Longueur'] = this.opts.fixed && m.dims ? m.dims : ftIn(s.lengthIn) + ' (' + cm(s.lengthIn) + ' cm)';
    if (!this.opts.fixed) p['Cotes'] = s.dimsMode === 'tyler' ? 'Largeur / épaisseur conseillées par ' + this.cfg.shaper + ' selon gabarit'
      : 'Largeur ' + (s.width || '?') + ' · Épaisseur ' + (s.thickness || '?');
    p[this.opts.fixed ? 'Planche finie (clear, sans ailerons)' : 'Prix de base'] = t.base ? t.base + ' ' + c : 'confirmé au rappel';
    this.selected().forEach(function (x) {
      var v = x.opt.name + (x.colors.filter(Boolean).length ? ' — ' + x.colors.filter(Boolean).join(' / ') : '');
      v += ' : ' + (x.price == null ? 'sur devis' : x.price + ' ' + c);
      p[x.cat.label + (x.cat.multi ? ' · ' + x.opt.name : '')] = v;
    });
    if (t.base) {
      p['Total estimé TTC'] = t.total + ' ' + c + (t.quote ? ' + options sur devis' : '');
      p['Acompte réglé'] = t.deposit + ' ' + c;
      p['Solde estimé'] = t.balance + ' ' + c;
    } else {
      p['Options choisies'] = t.extras + ' ' + c + (t.quote ? ' + options sur devis' : '');
      p['Acompte réglé'] = t.deposit + ' ' + c;
    }
    if (this.opts.delivery && !this.opts.fixed) p['Livraison'] = this.opts.delivery;
    var r = s.rider;
    var gab = [r.weight && r.weight + ' kg', r.height && r.height + ' cm', r.level].filter(Boolean).join(' · ');
    if (gab) p['Surfeur'] = gab;
    if (r.waves) p['Vagues'] = r.waves;
    if (r.spot) p['Spots'] = r.spot;
    if (r.notes) p['Notes'] = r.notes.slice(0, 480);
    return p;
  };

  Customizer.prototype.submit = function () {
    var self = this, s = this.state;
    if (s.busy || !s.model) return;
    s.busy = true; s.error = ''; this.updateBar();
    fetch(this.opts.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +this.opts.variantId, quantity: 1, properties: this.properties() }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || self.t('cartError', 'Erreur panier')); });
      window.location.href = self.opts.redirect;
    }).catch(function (err) {
      s.busy = false; s.error = err.message || self.t('genericError', 'Erreur — réessayez ou contactez-nous.'); self.updateBar();
    });
  };

  /* ---------- rendu ---------- */
  Customizer.prototype.render = function (scroll) {
    var s = this.state, m = this.model(), cfg = this.cfg, self = this;
    var steps = [this.t('stepShape', 'Le shape'), this.t('stepSize', 'La taille'), this.t('decoOptions', 'Déco & options'), this.t('stepYou', 'Vous')];
    var h = '<div class="bc-grid' + (this.opts.fixed ? ' bc-grid--single' : '') + '">';

    /* visuel (pas en mode pièce fixe : la galerie de la fiche montre déjà le shape) */
    if (!this.opts.fixed) {
    h += '<aside class="bc-visual">';
    if (m) {
      h += '<div class="bc-board"><img src="' + esc(m.images[s.view]) + '" alt="' + esc(cfg.brand + ' ' + m.name + ' — ' + (s.view === 'top' ? this.t('viewTop', 'vue dessus') : this.t('viewBottom', 'vue dessous'))) + '" loading="lazy"></div>';
      h += '<div class="bc-views">' + ['top', 'bottom'].map(function (v) {
        return '<button type="button" data-act="view" data-view="' + v + '" class="' + (s.view === v ? 'is-on' : '') + '">' + (v === 'top' ? esc(self.t('deckView', 'Dessus')) : esc(self.t('bottomView', 'Dessous'))) + '</button>';
      }).join('') + '</div>';
      h += '<p class="bc-visual-name">' + esc(m.name) + (s.lengthIn ? ' · ' + ftIn(s.lengthIn) : '') + '</p>';
      h += '<p class="bc-visual-note">' + esc(this.t('modelPhotoNote', 'Photo du modèle. La déco choisie est réalisée sur-mesure.')) + '</p>';
    } else {
      h += '<div class="bc-board bc-board--empty">' + (this.cfg.logo ? '<img class="bc-board-logo" src="' + esc(this.cfg.logo) + '" alt="' + esc(this.cfg.brand) + '" width="993" height="313">' : '') + '<span>' + esc(this.t('pickShape', 'Choisissez un shape')) + '</span></div>';
    }
    h += '</aside>';
    }

    /* étapes */
    h += '<div class="bc-main">';
    var fixed = this.opts.fixed;
    if (fixed) steps = [null, this.t('piece', 'La pièce'), this.t('finishOptions', 'Finition & options'), this.t('stepYou', 'Vous')];
    h += '<ol class="bc-steps">' + steps.map(function (l, i) {
      if (!l) return '';
      var n = i + 1, dis = n > 1 && !m, shown = fixed ? n - 1 : n;
      return '<li><button type="button" data-act="step" data-step="' + n + '" class="' + (s.step === n ? 'is-on' : '') + (n < s.step ? ' is-done' : '') + '"' + (dis ? ' disabled' : '') + '><b>' + shown + '</b><span>' + l + '</span></button></li>';
    }).join('') + '</ol>';

    if (s.step === 1) h += this.viewModels();
    if (s.step === 2 && m) h += fixed ? this.viewFixed() : this.viewSize();
    if (s.step === 3 && m) h += this.viewExtras();
    if (s.step === 4 && m) h += this.viewRider();
    h += '</div></div>';
    h += '<div class="bc-bar" data-bar></div>';

    this.root.innerHTML = h;
    this.updateBar();
    if (scroll) {
      var top = this.root.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  Customizer.prototype.viewModels = function () {
    var s = this.state, self = this;
    return '<h2 class="bc-h">' + esc(this.t('chooseShape', 'Choisissez votre shape')) + '</h2><div class="bc-models">' + this.cfg.models.map(function (m) {
      var mt = m.priceTiers || self.cfg.priceTiers;
      var from = Math.min.apply(null, mt.filter(function (t) { return t.maxIn >= m.minIn && t.minIn <= m.maxIn; }).map(function (t) { return t.price; }));
      return '<button type="button" class="bc-model' + (s.model === m.key ? ' is-on' : '') + '" data-act="model" data-key="' + esc(m.key) + '">' +
        '<span class="bc-model-img"><img src="' + esc(m.images.top) + '" alt="' + esc(m.name) + '" loading="lazy"></span>' +
        '<span class="bc-model-txt">' + (m.badge ? '<em class="bc-badge">' + esc(m.badge) + '</em>' : '') +
        '<strong>' + esc(m.name) + '</strong><i>' + esc(m.subtitle) + '</i><span>' + esc(m.suited) + '</span>' +
        '<small>' + ftIn(m.minIn) + ' → ' + ftIn(m.maxIn) + '<em><i>' + esc(self.t('from', 'dès')) + '</i> ' + from + '\u00a0' + self.cfg.currency + '</em></small></span></button>';
    }).join('') + '</div>';
  };

  Customizer.prototype.viewFixed = function () {
    var m = this.model(), cfg = this.cfg, t = this.totals(), c = cfg.currency;
    var h = '<div class="bc-panel bc-piece">';
    if (this.opts.fixedImage) h += '<figure class="bc-piece-img"><img src="' + esc(this.opts.fixedImage) + '" alt="' + esc(cfg.brand + ' ' + m.name + ' — shape vu de dessus') + '" loading="lazy"></figure>';
    h += '<div class="bc-piece-body"><p class="bc-piece-brand">' + esc(cfg.brand) + '</p><h2 class="bc-h">' + esc(m.name) + '</h2>';
    h += '<p class="bc-lead">' + esc(cfg.fixedIntro || '') + '</p>';
    h += '<dl class="bc-recap" style="margin:0 0 16px">' +
      (m.dims ? '<div><dt>' + esc(this.t('shapeDims', 'Cotes du shape')) + '</dt><dd>' + esc(m.dims) + '</dd></div>' : '') +
      (this.opts.fixedSku ? '<div><dt>' + esc(this.t('serial', 'N° de série')) + '</dt><dd>' + esc(this.opts.fixedSku) + '</dd></div>' : '') +
      '<div class="bc-recap-total"><dt>' + esc(this.t('finishedBoard', 'Planche finie, clear, sans ailerons')) + '</dt><dd>' + (t.base ? t.base + ' ' + c : this.t('priceOnCall', 'prix confirmé au rappel')) + '</dd></div></dl>';
    h += '<ul class="bc-included">' + cfg.included.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
    h += '<div class="bc-nav"><span></span><button type="button" class="bc-btn" data-act="step" data-step="3">Finition & options →</button></div>';
    return h + '</div></div>';
  };

  Customizer.prototype.viewSize = function () {
    var s = this.state, m = this.model(), cfg = this.cfg, t = this.tier(s.lengthIn), o = '';
    for (var i = m.minIn; i <= m.maxIn; i += (cfg.lengthStepIn || 1)) {
      o += '<option value="' + i + '"' + (i === s.lengthIn ? ' selected' : '') + '>' + ftIn(i) + ' — ' + cm(i) + ' cm</option>';
    }
    var h = '<div class="bc-panel"><h2 class="bc-h">' + esc(m.name) + '</h2><p class="bc-lead">' + esc(m.desc) + '</p>';
    h += '<label class="bc-field"><span>' + esc(this.t('length', 'Longueur')) + '</span><select data-field="length">' + o + '</select></label>';
    h += '<p class="bc-price-line">' + esc(this.t('priceBand', 'Tranche')) + ' ' + esc(t.label) + ' : <strong>' + t.price + ' ' + cfg.currency + '</strong> <small>' + esc(t.note || this.t('glassNote', 'polyester, volan inclus')) + '</small></p>';
    h += '<div class="bc-choice">' +
      '<button type="button" data-act="dims" data-mode="tyler" class="' + (s.dimsMode === 'tyler' ? 'is-on' : '') + '"><strong>' + esc(this.t('recommendedBy', 'Cotes conseillées par ')) + esc(cfg.shaper.split(' ')[0]) + '</strong><span>' + esc(this.t('recommendedHint', 'Largeur et épaisseur calées sur votre gabarit et votre surf. Recommandé.')) + '</span></button>' +
      '<button type="button" data-act="dims" data-mode="custom" class="' + (s.dimsMode === 'custom' ? 'is-on' : '') + '"><strong>' + esc(this.t('iHaveDims', "J'ai mes cotes")) + '</strong><span>' + esc(this.t('customDimsHint', 'Vous indiquez largeur et épaisseur.')) + '</span></button></div>';
    if (s.dimsMode === 'custom') {
      h += '<div class="bc-row"><label class="bc-field"><span>' + esc(this.t('width', 'Largeur')) + '</span><input data-field="width" value="' + esc(s.width) + '" placeholder=\'ex. 23"\'></label>' +
        '<label class="bc-field"><span>' + esc(this.t('thickness', 'Épaisseur')) + '</span><input data-field="thickness" value="' + esc(s.thickness) + '" placeholder=\'ex. 3 1/8"\'></label></div>';
    }
    if (m.refDims && m.refDims.length) {
      h += '<details class="bc-details"><summary>' + esc(this.t('refDims', 'Cotes de référence du modèle')) + '</summary><table><thead><tr><th>Long.</th><th>Larg.</th><th>Ép.</th><th></th></tr></thead><tbody>' +
        m.refDims.map(function (d) { return '<tr><td>' + esc(d.length) + '</td><td>' + esc(d.width) + '</td><td>' + esc(d.thickness) + '</td><td>' + esc(d.note) + '</td></tr>'; }).join('') +
        '</tbody></table><p>' + esc(m.dims) + '</p></details>';
    }
    h += '<ul class="bc-included">' + cfg.included.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
    h += this.nav(1, 3, this.t('decoOptions', 'Déco & options'));
    return h + '</div>';
  };

  Customizer.prototype.viewExtras = function () {
    var s = this.state, self = this, cfg = this.cfg, h = '<div class="bc-panel"><h2 class="bc-h">' + esc(this.t('decoOptions', 'Déco & options')) + '</h2>';
    cfg.extras.forEach(function (cat) {
      var sel = s.extras[cat.key] || {};
      h += '<div class="bc-cat" role="group" aria-label="' + esc(cat.label) + '"><h3>' + esc(cat.label) + '</h3>' + (cat.help ? '<p class="bc-help">' + esc(cat.help) + '</p>' : '');
      h += '<div class="bc-opts">';
      cat.options.forEach(function (o) {
        var p = self.optPrice(o), on = !!sel[o.key];
        h += '<button type="button" class="bc-opt' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="opt" data-cat="' + cat.key + '" data-opt="' + o.key + '">' +
          '<span>' + esc(o.name) + '</span><b>' + (p == null ? self.t('onRequest', 'sur devis') : '+ ' + p + ' ' + cfg.currency) + '</b></button>';
      });
      h += '</div>';
      cat.options.forEach(function (o) {
        if (!sel[o.key] || !o.colors) return;
        for (var k = 0; k < o.colors; k++) {
          h += '<div class="bc-colors"><span>' + (o.colors > 1 ? esc(self.t('color', 'Couleur')) + ' ' + (k + 1) + (k === 0 ? ' ' + esc(self.t('deckSuffix', '(pont)')) : ' ' + esc(self.t('bottomSuffix', '(carène)'))) : esc(self.t('color', 'Couleur'))) +
            (sel[o.key].colors[k] ? ' : <b>' + esc(sel[o.key].colors[k]) + '</b>' : '') + '</span><div>' +
            cfg.palette.map(function (c) {
              return '<button type="button" title="' + esc(c.name) + '" aria-label="' + esc(c.name) + '" class="bc-sw' + (sel[o.key].colors[k] === c.name ? ' is-on' : '') +
                '" style="background:' + esc(c.hex) + '" data-act="color" data-cat="' + cat.key + '" data-opt="' + o.key + '" data-slot="' + k + '" data-name="' + esc(c.name) + '"></button>';
            }).join('') + '</div></div>';
        }
      });
      h += '</div>';
    });
    h += '<p class="bc-help">' + esc(this.t('otherIdeaHelp', 'Une autre idée (teinte précise, résine abstraite, logo…) ? Notez-la à l\'étape suivante : on la chiffre avec vous au rappel.')) + '</p>';
    h += this.nav(2, 4, this.t('lastStep', 'Dernière étape'));
    return h + '</div>';
  };

  Customizer.prototype.viewRider = function () {
    var r = this.state.rider, cfg = this.cfg;
    var sel = function (f, list, ph) {
      return '<select data-field="' + f + '"><option value="">' + ph + '</option>' + list.map(function (x) {
        return '<option' + (r[f] === x ? ' selected' : '') + '>' + esc(x) + '</option>';
      }).join('') + '</select>';
    };
    var h = '<div class="bc-panel"><h2 class="bc-h">' + esc(this.t('aboutYou', 'Parlez-nous de vous')) + '</h2><p class="bc-lead">' + esc(this.t('riderLeadBefore', 'Ces infos servent à ')) + esc(cfg.shaper.split(' ')[0]) + esc(this.t('riderLeadAfter', ' pour caler les cotes. On vous rappelle sous 24 h pour valider chaque détail avant le shape.')) + '</p>';
    h += '<div class="bc-row"><label class="bc-field"><span>' + esc(this.t('weightKg', 'Poids (kg)')) + '</span><input type="number" inputmode="numeric" data-field="weight" value="' + esc(r.weight) + '"></label>' +
      '<label class="bc-field"><span>' + esc(this.t('heightCm', 'Taille (cm)')) + '</span><input type="number" inputmode="numeric" data-field="height" value="' + esc(r.height) + '"></label></div>';
    h += '<div class="bc-row"><label class="bc-field"><span>' + esc(this.t('level', 'Niveau')) + '</span>' + sel('level', cfg.rider.levels, this.t('choose', 'Choisir')) + '</label>' +
      '<label class="bc-field"><span>' + esc(this.t('wavesSurfed', 'Vagues surfées')) + '</span>' + sel('waves', cfg.rider.waves, this.t('choose', 'Choisir')) + '</label></div>';
    h += '<label class="bc-field"><span>' + esc(this.t('usualSpots', 'Spots habituels')) + '</span><input data-field="spot" value="' + esc(r.spot) + '" placeholder="' + esc(this.t('spotsPlaceholder', 'ex. Vert Bois, Côte des Basques')) + '"></label>';
    h += '<label class="bc-field"><span>' + esc(this.t('notesToShaper', 'Notes pour le shaper')) + '</span><textarea rows="3" data-field="notes" maxlength="480" placeholder="' + esc(this.t('notesPlaceholder', 'Planche actuelle, ce que vous cherchez, idée de déco…')) + '">' + esc(r.notes) + '</textarea></label>';
    h += this.recap();
    h += this.nav(3, null);
    return h + '</div>';
  };

  Customizer.prototype.recap = function () {
    var t = this.totals(), c = this.cfg.currency, m = this.model(), s = this.state, self = this;
    var h = '<div class="bc-recap"><h3>' + esc(this.t('yourBoard', 'Votre planche')) + '</h3><dl>';
    h += '<div><dt>' + esc(m.name) + ' · ' + ftIn(s.lengthIn) + '</dt><dd>' + (t.base ? t.base + ' ' + c : esc(this.t('priceOnCall', 'confirmé au rappel'))) + '</dd></div>';
    this.selected().forEach(function (x) {
      var col = x.colors.filter(Boolean).join(' / ');
      h += '<div><dt>' + esc(x.cat.label + ' — ' + x.opt.name) + (col ? ' <small>' + esc(col) + '</small>' : '') + '</dt><dd>' + (x.price == null ? esc(self.t('onRequest', 'sur devis')) : x.price + ' ' + c) + '</dd></div>';
    });
    if (t.base) h += '<div class="bc-recap-total"><dt>' + esc(this.t('totalEstimated', 'Total estimé TTC')) + '</dt><dd>' + t.total + ' ' + c + (t.quote ? ' *' : '') + '</dd></div>';
    else h += '<div class="bc-recap-total"><dt>' + esc(this.t('optionsChosen', 'Options choisies')) + '</dt><dd>' + t.extras + ' ' + c + (t.quote ? ' *' : '') + '</dd></div>';
    h += '<div><dt>' + esc(this.t('depositToday', "Acompte aujourd'hui")) + '</dt><dd>' + t.deposit + ' ' + c + '</dd></div>';
    h += t.base ? '<div><dt>' + esc(this.t('balanceOnDelivery', 'Solde à la livraison')) + '</dt><dd>' + t.balance + ' ' + c + '</dd></div></dl>' : '<div><dt>' + esc(this.t('balance', 'Solde')) + '</dt><dd>' + esc(this.t('balanceQuoted', 'devis confirmé au rappel')) + '</dd></div></dl>';
    if (t.quote) h += '<p class="bc-help">' + esc(this.t('quoteFootnote', '* hors options sur devis, chiffrées au rappel.')) + '</p>';
    return h + '</div>';
  };

  Customizer.prototype.nav = function (prev, next, label) {
    return '<div class="bc-nav">' + (prev ? '<button type="button" class="bc-btn bc-btn--ghost" data-act="step" data-step="' + prev + '">' + esc(this.t('back', 'Retour')) + '</button>' : '<span></span>') +
      (next ? '<button type="button" class="bc-btn" data-act="step" data-step="' + next + '">' + label + ' →</button>' : '') + '</div>';
  };

  Customizer.prototype.updateBar = function () {
    var bar = this.root.querySelector('[data-bar]'); if (!bar) return;
    var s = this.state, m = this.model(), t = this.totals(), c = this.cfg.currency;
    var h = '<div class="bc-bar-in"><div class="bc-bar-info">';
    if (m) {
      h += '<strong>' + esc(m.name) + ' ' + ftIn(s.lengthIn) + (t.base ? ' · ' + t.total + ' ' + c + (t.quote ? ' *' : '') : '') + '</strong>';
      h += '<span>' + esc(this.t('depositWord', 'Acompte')) + ' ' + t.deposit + ' ' + c + (t.base ? ' · ' + esc(this.t('balanceLower', 'solde')) + ' ' + t.balance + ' ' + c + ' ' + esc(this.t('onDelivery', 'à la livraison')) : ' · ' + esc(this.t('boardPriceOnCall', 'prix de la planche confirmé au rappel'))) + '</span>';
    } else h += '<strong>' + esc(this.t('buildYour', 'Construisez votre')) + ' ' + esc(this.cfg.brand) + '</strong><span>' + esc(this.t('depositWord', 'Acompte')) + ' ' + this.cfg.deposit + ' ' + c + ' · ' + esc(this.t('balanceOnDeliveryShort', 'solde à la livraison')) + '</span>';
    h += '</div>';
    if (this.opts.delivery) h += '<div class="bc-bar-delivery">' + esc(this.opts.delivery) + (this.opts.deadline ? '<small>' + esc(this.opts.deadline) + '</small>' : '') + '</div>';
    if (m && s.step === 4) h += '<button type="button" class="bc-btn bc-btn--cta" data-act="submit"' + (s.busy ? ' disabled' : '') + '>' + (s.busy ? esc(this.t('oneMoment', 'Un instant…')) : esc(this.t('bookDeposit', 'Réserver — acompte')) + ' ' + t.deposit + ' ' + c) + '</button>';
    else if (m) h += '<button type="button" class="bc-btn bc-btn--cta" data-act="step" data-step="' + Math.min(4, s.step + 1) + '">' + esc(this.t('continue', 'Continuer')) + '</button>';
    h += '</div>';
    if (s.error) h += '<p class="bc-error">' + esc(s.error) + '</p>';
    bar.innerHTML = h;
  };

  function boot() {
    document.querySelectorAll('[data-board-customizer]').forEach(function (el) {
      if (!el.__bc) el.__bc = new Customizer(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
